import { Recipe } from '../model/types';

export const SURFACE_RECIPES: Record<string, Recipe[]> = {
  wall: [
    {
      id: 'recipe_wall_putty_paint',
      name: 'Стены под покраску (Эталон)',
      nameKey: 'recipe.wall_putty_paint.name',
      description: 'Полный цикл: грунт → базовая шпаклевка → стеклохолст → предфинишная → финишная → шлифовка → акриловый уголок → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_glass_fiber', coefficient: 1 },
        { serviceId: 's_putty_mid', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_corner_acrylic', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_putty_paint_simple',
      name: 'Стены под покраску (Базовый)',
      nameKey: 'recipe.wall_putty_paint_simple.name',
      description: 'Грунт → базовая шпаклевка → финишная → шлифовка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_putty_wallpaper',
      name: 'Стены под обои (Эталон)',
      nameKey: 'recipe.wall_putty_wallpaper.name',
      description: 'Грунт → базовая шпаклевка → финишная → шлифовка → поклейка обоев',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_wallpaper', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_wallpaper_simple',
      name: 'Стены под обои (Базовый)',
      nameKey: 'recipe.wall_wallpaper_simple.name',
      description: 'Грунт → шпаклевка базовая → обои',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_wallpaper', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_putty_paint_ceiling',
      name: 'Стены + Потолок под покраску (Эталон)',
      nameKey: 'recipe.wall_putty_paint_ceiling.name',
      description: 'Полный цикл отделки стен и потолка: шпаклевка → шлифовка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_primer_ceil', coefficient: 1 },
        { serviceId: 's_ceil_putty', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_glass_fiber', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_corner_acrylic', coefficient: 1 },
        { serviceId: 's_ceil_paint', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_plaster_beacon',
      name: 'Стены: штукатурка маячная + под покраску',
      nameKey: 'recipe.wall_plaster_beacon_paint.name',
      description: 'Грунт → бетоноконтакт → штукатурка маячная → перфоугол → шпаклевка → финиш → шлифовка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_betokontakt', coefficient: 1 },
        { serviceId: 's_plaster_beacon', coefficient: 1 },
        { serviceId: 's_corner_perf', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_corner_acrylic', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_plaster_visual',
      name: 'Стены: штукатурка визуальная + под обои',
      nameKey: 'recipe.wall_plaster_visual_wallpaper.name',
      description: 'Грунт → штукатурка визуальная → шпаклевка базовая → обои',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_plaster_visual', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_wallpaper', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_decor_plaster',
      name: 'Стены: декоративная штукатурка',
      nameKey: 'recipe.wall_decor_plaster.name',
      description: 'Грунт → штукатурка маячная → шпаклевка → шлифовка → декоративное покрытие',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_plaster_beacon', coefficient: 1 },
        { serviceId: 's_putty_base', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_decor_plaster', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_tile_bathroom',
      name: 'Стены: плитка в ванной (под ключ)',
      nameKey: 'recipe.wall_tile_bathroom.name',
      description: 'Грунтовка → гидроизоляция → штукатурка → плитка стандартная + затирка + герметизация',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_waterproof_wall', coefficient: 1 },
        { serviceId: 's_plaster_beacon', coefficient: 1 },
        { serviceId: 's_tile_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_gkl_insulation',
      name: 'Стены: ГКЛ облицовка с шумоизоляцией',
      nameKey: 'recipe.wall_gkl_insulation.name',
      description: 'Каркас → шумоизоляция → обшивка ГКЛ → заделка швов → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_frame_wall', coefficient: 1 },
        { serviceId: 's_soundproof', coefficient: 1 },
        { serviceId: 's_gkl_sheet_wall', coefficient: 1 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_wall_gkl_partition',
      name: 'Перегородка ГКЛ (под ключ)',
      nameKey: 'recipe.wall_gkl_partition.name',
      description: 'Каркас → шумоизоляция → обшивка ГКЛ 2 стороны → заделка швов → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_frame_part', coefficient: 1 },
        { serviceId: 's_soundproof', coefficient: 1 },
        { serviceId: 's_gkl_sheet_wall', coefficient: 2 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
  ],
  floor: [
    {
      id: 'recipe_floor_laminate',
      name: 'Полы: ламинат (под ключ)',
      nameKey: 'recipe.floor_laminate.name',
      description: 'Грунтовка → стяжка → наливной пол → ламинат → плинтус',
      layers: [
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_damp_proof', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_laminate', coefficient: 1 },
        { serviceId: 's_skirting_pvc', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_floor_tile',
      name: 'Полы: плитка (под ключ)',
      nameKey: 'recipe.floor_tile.name',
      description: 'Грунтовка → гидроизоляция → стяжка → плитка + затирка + герметизация',
      layers: [
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_hydro', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_tile_floor_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_skirting_pvc', coefficient: 1 },
        { serviceId: 's_cover', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_floor_tile_bathroom',
      name: 'Полы: плитка в ванной (под ключ)',
      nameKey: 'recipe.floor_tile_bathroom.name',
      description: 'Грунтовка → гидроизоляция → стяжка → наливной → плитка + затирка + душевой поддон + герметизация',
      layers: [
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_hydro', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_tile_floor_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_shower_tray', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_cover', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_floor_spc',
      name: 'Полы: кварцвинил SPC (под ключ)',
      nameKey: 'recipe.floor_spc.name',
      description: 'Грунтовка → стяжка → наливной пол → кварцвинил → плинтус',
      layers: [
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_spc', coefficient: 1 },
        { serviceId: 's_skirting_pvc', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_floor_parquet',
      name: 'Полы: паркетная доска (под ключ)',
      nameKey: 'recipe.floor_parquet.name',
      description: 'Грунтовка → стяжка → наливной пол → паркетная доска → плинтус МДФ',
      layers: [
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_floor_heat_mat', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_parquet', coefficient: 1 },
        { serviceId: 's_skirting_mdf', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
  ],
  ceiling: [
    {
      id: 'recipe_ceil_paint',
      name: 'Потолок: покраска (под ключ)',
      nameKey: 'recipe.ceil_paint.name',
      description: 'Грунтовка → шпаклевка → финишная → шлифовка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_primer_ceil', coefficient: 1 },
        { serviceId: 's_ceil_putty', coefficient: 1 },
        { serviceId: 's_ceil_paint', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_ceil_stretch',
      name: 'Потолок: натяжной',
      nameKey: 'recipe.ceil_stretch.name',
      description: 'Натяжной потолок (установщик привозит и монтирует)',
      layers: [
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_ceil_stretch', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_ceil_gkl',
      name: 'Потолок: ГКЛ (под ключ)',
      nameKey: 'recipe.ceil_gkl.name',
      description: 'Каркас → шумоизоляция → обшивка → заделка швов → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_frame_ceil', coefficient: 1 },
        { serviceId: 's_soundproof_ceil', coefficient: 1 },
        { serviceId: 's_gkl_sheet_ceil', coefficient: 1 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_ceil_putty', coefficient: 1 },
        { serviceId: 's_ceil_paint', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_ceil_plaster',
      name: 'Потолок: штукатурка + покраска',
      nameKey: 'recipe.ceil_plaster.name',
      description: 'Грунтовка → штукатурка потолка → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_primer_ceil', coefficient: 1 },
        { serviceId: 's_ceil_plaster', coefficient: 1 },
        { serviceId: 's_ceil_putty', coefficient: 1 },
        { serviceId: 's_ceil_paint', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
  ],
  gkl: [
    {
      id: 'recipe_gkl_partition_paint',
      name: 'Перегородка ГКЛ под покраску',
      nameKey: 'recipe.gkl_partition_paint.name',
      description: 'Каркас → шумоизоляция → обшивка 2 стороны → швы → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_frame_part', coefficient: 1 },
        { serviceId: 's_soundproof', coefficient: 1 },
        { serviceId: 's_gkl_sheet_wall', coefficient: 2 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_corner_acrylic', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_gkl_partition_tile',
      name: 'Перегородка ГКЛ под плитку (ванная)',
      nameKey: 'recipe.gkl_partition_tile.name',
      description: 'Каркас → шумоизоляция → двойная обшивка ГКВЛ → швы → грунт → гидроизоляция → плитка',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_frame_part', coefficient: 1 },
        { serviceId: 's_soundproof', coefficient: 1 },
        { serviceId: 's_gkl_sheet_wall2', coefficient: 2 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_waterproof_wall', coefficient: 1 },
        { serviceId: 's_tile_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_gkl_wall_cladding',
      name: 'Облицовка стены ГКЛ под покраску',
      nameKey: 'recipe.gkl_wall_cladding.name',
      description: 'Каркас → шумоизоляция → обшивка → швы → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_frame_wall', coefficient: 1 },
        { serviceId: 's_soundproof', coefficient: 1 },
        { serviceId: 's_gkl_sheet_wall', coefficient: 1 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_sand_wall', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_gkl_box',
      name: 'Короб ГКЛ (трубы/инсталляция)',
      nameKey: 'recipe.gkl_box.name',
      description: 'Каркас → обшивка → швы → шпаклевка → покраска',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_gkl_box', coefficient: 1 },
        { serviceId: 's_seam_gkl', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_putty_finish', coefficient: 1 },
        { serviceId: 's_paint', coefficient: 2 },
        { serviceId: 's_cover_floor', coefficient: 1 },
      ],
    },
  ],
  tile: [
    {
      id: 'recipe_tile_walls_bathroom',
      name: 'Плитка: стены ванной (под ключ)',
      nameKey: 'recipe.tile_walls_bathroom.name',
      description: 'Демонтаж → грунтовка → гидроизоляция → штукатурка → плитка + затирка + герметизация + откосы',
      layers: [
        { serviceId: 's_demo_tile', coefficient: 1 },
        { serviceId: 's_demo_plaster', coefficient: 1 },
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_waterproof_wall', coefficient: 1 },
        { serviceId: 's_plaster_beacon', coefficient: 1 },
        { serviceId: 's_tile_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_slopes', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_tile_floor_bathroom',
      name: 'Плитка: пол ванной (под ключ)',
      nameKey: 'recipe.tile_floor_bathroom.name',
      description: 'Демонтаж → грунтовка → гидроизоляция → стяжка → наливной → плитка + затирка + душевой поддон',
      layers: [
        { serviceId: 's_demo_floor', coefficient: 1 },
        { serviceId: 's_demo_screed', coefficient: 1 },
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_hydro', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_tile_floor_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_shower_tray', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_cover', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_tile_kitchen_apron',
      name: 'Плитка: кухонный фартук',
      nameKey: 'recipe.tile_kitchen_apron.name',
      description: 'Грунтовка → штукатурка → плитка + затирка + герметизация',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_plaster_beacon', coefficient: 1 },
        { serviceId: 's_tile_std', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_tile_floor_kitchen',
      name: 'Плитка: пол кухни (под ключ)',
      nameKey: 'recipe.tile_floor_kitchen.name',
      description: 'Демонтаж покрытия → стяжка → плитка + затирка + плинтус',
      layers: [
        { serviceId: 's_demo_floor', coefficient: 1 },
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_tile_floor_std', coefficient: 1 },
        { serviceId: 's_grout_cem', coefficient: 1 },
        { serviceId: 's_skirting_pvc', coefficient: 1 },
        { serviceId: 's_cover', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
  ],
  plumbing: [
    {
      id: 'recipe_plumbing_bathroom_full',
      name: 'Сантехника: ванная под ключ',
      nameKey: 'recipe.plumbing_bathroom_full.name',
      description: 'Демонтаж старой сантехники → водоснабжение 2 т. → канализация → инсталляция → смесители → унитаз → полотенцесушитель',
      layers: [
        { serviceId: 's_demo_bath', coefficient: 1 },
        { serviceId: 's_demo_toilet', coefficient: 1 },
        { serviceId: 's_demo_sink', coefficient: 1 },
        { serviceId: 's_plumb_water', coefficient: 2 },
        { serviceId: 's_plumb_sewer', coefficient: 1 },
        { serviceId: 's_plumb_install_frame', coefficient: 1 },
        { serviceId: 's_plumb_device', coefficient: 1 },
        { serviceId: 's_plumb_mix_hidden', coefficient: 1 },
        { serviceId: 's_plumb_hyg', coefficient: 1 },
        { serviceId: 's_towel', coefficient: 1 },
        { serviceId: 's_filter_main', coefficient: 1 },
        { serviceId: 's_plumb_valve', coefficient: 2 },
      ],
    },
    {
      id: 'recipe_plumbing_kitchen',
      name: 'Сантехника: кухня',
      nameKey: 'recipe.plumbing_kitchen.name',
      description: 'Водоснабжение → канализация → смеситель → фильтр → запорные краны',
      layers: [
        { serviceId: 's_plumb_water', coefficient: 1 },
        { serviceId: 's_plumb_sewer', coefficient: 1 },
        { serviceId: 's_plumb_device', coefficient: 1 },
        { serviceId: 's_filter_fine', coefficient: 1 },
        { serviceId: 's_filter_main', coefficient: 1 },
        { serviceId: 's_plumb_valve', coefficient: 2 },
      ],
    },
    {
      id: 'recipe_plumbing_basic',
      name: 'Сантехника: базовый набор',
      nameKey: 'recipe.plumbing_basic.name',
      description: 'Водоснабжение + канализация + унитаз + смеситель + полотенцесушитель',
      layers: [
        { serviceId: 's_plumb_water', coefficient: 2 },
        { serviceId: 's_plumb_sewer', coefficient: 1 },
        { serviceId: 's_plumb_device', coefficient: 1 },
        { serviceId: 's_towel', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_plumbing_toilet',
      name: 'Сантехника: унитаз + инсталляция',
      nameKey: 'recipe.plumbing_toilet.name',
      description: 'Демонтаж → канализация → инсталляция → унитаз',
      layers: [
        { serviceId: 's_demo_toilet', coefficient: 1 },
        { serviceId: 's_plumb_sewer', coefficient: 1 },
        { serviceId: 's_plumb_install_frame', coefficient: 1 },
        { serviceId: 's_plumb_device', coefficient: 1 },
      ],
    },
  ],
  electrical: [
    {
      id: 'recipe_elec_bathroom',
      name: 'Электрика: ванная',
      nameKey: 'recipe.elec_bathroom.name',
      description: 'Штробление → кабель → подрозетники → розетки + выключатель + вытяжка + теплый пол',
      layers: [
        { serviceId: 's_elec_strobe', coefficient: 1 },
        { serviceId: 's_elec_cable', coefficient: 1 },
        { serviceId: 's_elec_point_rough', coefficient: 1 },
        { serviceId: 's_elec_mech', coefficient: 1 },
        { serviceId: 's_elec_fan', coefficient: 1 },
        { serviceId: 's_floor_heat', coefficient: 1 },
        { serviceId: 's_elec_contact', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_elec_room',
      name: 'Электрика: комната (базовый)',
      nameKey: 'recipe.elec_room.name',
      description: 'Штробление → кабель → подрозетники → розетки + выключатель + вывод под люстру',
      layers: [
        { serviceId: 's_elec_strobe', coefficient: 1 },
        { serviceId: 's_elec_cable', coefficient: 1 },
        { serviceId: 's_elec_point_rough', coefficient: 1 },
        { serviceId: 's_elec_wire_out', coefficient: 1 },
        { serviceId: 's_elec_mech', coefficient: 1 },
        { serviceId: 's_elec_light', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_elec_kitchen',
      name: 'Электрика: кухня',
      nameKey: 'recipe.elec_kitchen.name',
      description: 'Штробление → кабель → подрозетники → розетки (силовая + обычная) + выключатель',
      layers: [
        { serviceId: 's_elec_strobe', coefficient: 1 },
        { serviceId: 's_elec_cable', coefficient: 1 },
        { serviceId: 's_elec_point_rough', coefficient: 1 },
        { serviceId: 's_elec_switch_block', coefficient: 1 },
        { serviceId: 's_elec_mech', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_elec_full_flat',
      name: 'Электрика: квартира (щит + разводка)',
      nameKey: 'recipe.elec_full_flat.name',
      description: 'Щит → УЗО → штробление → кабель → подрозетники → розетки + выключатели',
      layers: [
        { serviceId: 's_elec_shield_full', coefficient: 1 },
        { serviceId: 's_elec_rcd', coefficient: 1 },
        { serviceId: 's_elec_strobe', coefficient: 1 },
        { serviceId: 's_elec_cable', coefficient: 1 },
        { serviceId: 's_elec_point_rough', coefficient: 1 },
        { serviceId: 's_elec_mech', coefficient: 1 },
        { serviceId: 's_cover', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
  ],
  bathroom: [
    {
      id: 'recipe_bathroom_full',
      name: 'Ванная: полный цикл (под ключ)',
      nameKey: 'recipe.bathroom_full.name',
      description: 'Полный демонтаж → черновые работы → чистовая отделка стен и пола → потолок → сантехника → электрика → уборка',
      layers: [
        { serviceId: 's_demo_tile', coefficient: 1 },
        { serviceId: 's_demo_floor', coefficient: 1 },
        { serviceId: 's_demo_plaster', coefficient: 1 },
        { serviceId: 's_demo_toilet', coefficient: 1 },
        { serviceId: 's_demo_bath', coefficient: 1 },
        { serviceId: 's_demo_sink', coefficient: 1 },
        { serviceId: 's_demo_pipes', coefficient: 1 },
        { serviceId: 's_demo_sewer', coefficient: 1 },
        { serviceId: 's_demo_wiring', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 2 },
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_grunt', coefficient: 1 },
        { serviceId: 's_waterproof_wall', coefficient: 1 },
        { serviceId: 's_hydro', coefficient: 1 },
        { serviceId: 's_plaster_beacon', coefficient: 1 },
        { serviceId: 's_tile_std', coefficient: 1 },
        { serviceId: 's_grunt_floor', coefficient: 1 },
        { serviceId: 's_screed', coefficient: 1 },
        { serviceId: 's_self_level', coefficient: 1 },
        { serviceId: 's_tile_floor_std', coefficient: 1 },
        { serviceId: 's_shower_tray', coefficient: 1 },
        { serviceId: 's_grout_epox', coefficient: 1 },
        { serviceId: 's_slopes', coefficient: 1 },
        { serviceId: 's_silicone', coefficient: 1 },
        { serviceId: 's_ceil_paint', coefficient: 1 },
        { serviceId: 's_plumb_water', coefficient: 2 },
        { serviceId: 's_plumb_sewer', coefficient: 1 },
        { serviceId: 's_plumb_install_frame', coefficient: 1 },
        { serviceId: 's_plumb_device', coefficient: 1 },
        { serviceId: 's_plumb_mix_hidden', coefficient: 1 },
        { serviceId: 's_plumb_hyg', coefficient: 1 },
        { serviceId: 's_towel', coefficient: 1 },
        { serviceId: 's_filter_main', coefficient: 1 },
        { serviceId: 's_elec_strobe', coefficient: 1 },
        { serviceId: 's_elec_cable', coefficient: 1 },
        { serviceId: 's_elec_point_rough', coefficient: 1 },
        { serviceId: 's_elec_mech', coefficient: 1 },
        { serviceId: 's_elec_fan', coefficient: 1 },
        { serviceId: 's_sill', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
  ],
  general: [
    {
      id: 'recipe_general_demo',
      name: 'Демонтаж: полный цикл (комната)',
      nameKey: 'recipe.general_demo.name',
      description: 'Обои → краска → штукатурка → плитка → покрытие пола + укрывка + мусор',
      layers: [
        { serviceId: 's_demo_wallpaper', coefficient: 1 },
        { serviceId: 's_demo_paint', coefficient: 1 },
        { serviceId: 's_demo_plaster', coefficient: 1 },
        { serviceId: 's_demo_tile', coefficient: 1 },
        { serviceId: 's_demo_floor', coefficient: 1 },
        { serviceId: 's_cover', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 2 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_general_openings',
      name: 'Окна/Двери: полный цикл',
      nameKey: 'recipe.general_openings.name',
      description: 'Штукатурка откосов + подоконник + герметизация + москитная сетка + укрывка',
      layers: [
        { serviceId: 's_masking', coefficient: 1 },
        { serviceId: 's_slopes', coefficient: 1 },
        { serviceId: 's_sill', coefficient: 1 },
        { serviceId: 's_window_seal', coefficient: 1 },
        { serviceId: 's_window_mesh', coefficient: 1 },
        { serviceId: 's_cover_floor', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
        { serviceId: 's_clean', coefficient: 1 },
      ],
    },
    {
      id: 'recipe_general_door_install',
      name: 'Дверь: полный монтаж',
      nameKey: 'recipe.general_door_install.name',
      description: 'Демонтаж старой → коробка → фурнитура → обналичка → доборы',
      layers: [
        { serviceId: 's_demo_door', coefficient: 1 },
        { serviceId: 's_door_interior_install', coefficient: 1 },
        { serviceId: 's_door_set', coefficient: 1 },
        { serviceId: 's_door_trimming', coefficient: 1 },
        { serviceId: 's_door_casing', coefficient: 1 },
        { serviceId: 's_slopes', coefficient: 1 },
        { serviceId: 's_garbage', coefficient: 1 },
      ],
    },
  ],
};